import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      light: '#E9FFEF',
      main: '#129B4E',
      dark: '#0A582D',
    },
    error: {
      main: '#EB3123',
    },
    background: {
      default: '#F4F8F9',
    },
    info: {
      main: '#00A9DE',
      light: '#B3ECFE',
    },
  },
  typography: {
    fontFamily: 'Noto Sans Thai',
    h1 : {
      fontWeight: '600',
    },
    h2 : {
      fontWeight: '600',
    },
    h3 : {
      fontWeight: '600',
    },
    h4 : {
      fontWeight: '600',
    },
    h5 : {
      fontWeight: '600',
    },
    h6 : {
      fontWeight: '600',
    },
    subtitle1: {
      fontWeight: '600',
    },
    body2: {
      color: '#000000',
    },
  },
  shape: {
    borderRadius: 2,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          paddingTop: '10px',
          paddingBottom: '10px',
          borderRadius: '5px',
          boxShadow: 'none',
          fontSize: '16px',
          whiteSpace: 'nowrap',
          '& p': {
            lineHeight: '1.61',
          },
          '& .MuiButton-endIcon': {
            marginLeft: '12px',
          },
          '& .MuiButton-startIcon': {
            marginRight: '12px',
          },
          textTransform: 'none',
          '&.Mui-disabled':{
            background:'rgba(17, 155, 78, 0.5)',
            color: '#fff',
          }
        },
        
      },
      
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          backgroundColor: '#36C690',
          color: '#fff',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          padding: '2px 12px 2px 12px',
        },
        input: {
          padding: '2px 12px 2px 12px',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          padding: '5px',
          borderRadius: '5px',
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: '#759583',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: '#759583',},
          // '& .Mui-disabled': {},
          '& .Mui-disabled+fieldset': {backgroundColor:'#F4F5F6', borderColor:'#96A39E'},
        },
        input: {
          padding: '5px',
          borderRadius: '5px',
          fontSize: '16px',
        },
        
      },
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          paddingTop: '0px',
        },
        item: {
          paddingTop: '0px',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          marginBottom: '0px',
          textTransform: 'none',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px',
          borderBottomLeftRadius: '10px',
          borderBottomRightRadius: '10px',
          padding: '10px',
        },
      },
    },
  },
});

export default theme;
